module.exports = __webpack_public_path__ + "img/banner-two5.36c90241.png";